var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-br-arrow-right",
    clipPath: "url(#clip0_19014_9936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.8787 5.60598L0.959702 9.52499C0.323326 10.1918 -0.0317307 11.0782 -0.0317307 12C-0.0317307 12.9218 0.323326 13.8081 0.959702 14.475L4.8787 18.394C5.15996 18.6754 5.54149 18.8335 5.93935 18.8336C6.33721 18.8337 6.71881 18.6758 7.0002 18.3945C7.2816 18.1132 7.43974 17.7317 7.43983 17.3338C7.43992 16.936 7.28196 16.5544 7.0007 16.273L4.2207 13.492L22.4707 13.469C22.8685 13.469 23.2501 13.311 23.5314 13.0296C23.8127 12.7483 23.9707 12.3668 23.9707 11.969C23.9707 11.5712 23.8127 11.1896 23.5314 10.9083C23.2501 10.627 22.8685 10.469 22.4707 10.469L4.2397 10.492L7.0007 7.72698C7.27394 7.44408 7.42513 7.06518 7.42171 6.67188C7.41829 6.27859 7.26054 5.90237 6.98243 5.62426C6.70432 5.34614 6.3281 5.18839 5.9348 5.18497C5.54151 5.18155 5.16261 5.33275 4.8797 5.60598H4.8787Z",
    fill: "#011602"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19014_9936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 -1 24 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.3fac47a61e27e4a359ace96063a2214b.svg";
export { ForwardRef as ReactComponent };